import React from "react";

export default function EmpresasSummary({ resumen, onQuickFilter, activeKey }) {
  const cards = [
    { key: "total", label: "Empresas registradas", value: resumen.total, icon: "bi bi-buildings", accent: "total" },
    { key: "activas", label: "Activas", value: resumen.activas, icon: "bi bi-check2-circle", accent: "success" },
    { key: "internas", label: "Internas", value: resumen.internas, icon: "bi bi-shield-shaded", accent: "info" },
    { key: "proveedores", label: "Proveedores", value: resumen.proveedores, icon: "bi bi-truck", accent: "warning" },
    { key: "externas", label: "Externas", value: resumen.externas, icon: "bi bi-globe-americas", accent: "secondary" },
  ];

  return (
    <div className="management-card emp-summary-card mb-4">
      <div className="emp-summary-grid">
        {cards.map((card) => (
          <button
            key={card.key}
            type="button"
            className={`management-stat-card emp-card ${card.accent} ${activeKey === card.key ? "active" : ""}`}
            onClick={() => onQuickFilter?.(card.key)}
          >
            <div className="management-stat-icon">
              <i className={card.icon} />
            </div>
            <div>
              <p className="management-stat-label mb-1">{card.label}</p>
              <p className="management-stat-value mb-0">{card.value}</p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}

